import searchBarStyles from 'components/home/SearchPopup/styles.module.scss';

export const setFocusToSearchInput = () => {
  const input = document.querySelector<HTMLInputElement>(`form.${searchBarStyles.search} > input`);

  if (input) {
    input.focus();
  }
};
